import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {EmailMakerMoreOptionsSheet, openEmailMakerMoreOptionsSheet} from '@EmailMakerReact/components/email-maker-more-options-sheet/email-maker-more-options-sheet';
import {ICON_MORE_HORIZONTAL} from '../../publishing-options-menu.types';
import type {MobileMoreOptionsButtonProps} from './mobile-more-options-button.types';

export function MobileMoreOptionsButton({editor}: MobileMoreOptionsButtonProps): ReactElement {
  return (
    <>
      <Icon
        icon={ICON_MORE_HORIZONTAL}
        shape={IconShape.SQUARE}
        type={IconType.SECONDARY}
        size={IconSize.SIZE_ICON_20}
        ariaLabel={window.i18next.t('pmwjs_more_options')}
        onClick={openEmailMakerMoreOptionsSheet}
      />
      <EmailMakerMoreOptionsSheet editor={editor} />
    </>
  );
}
